<div class="w-screen h-screen grid grid-cols-3">
  <div class="bg-primary-one relative effect col-span-2 h-full overflow-hidden justify-center"></div>
  <div class="bg-white flex flex-col p-16 h-full justify-center gap-10 h-">
    <img src="/assets/images/beexact-logo.png" alt="BeExact Logo" class="h-10 object-contain object-left" />
    <div class="flex flex-col gap-1">
      <app-title>{{ 'page.redirect.title' | translate }}</app-title>
      <app-loader></app-loader>
    </div>
  </div>
</div>
